<template>
  <div class="schoolPay">
    <div class="des">校园卡扣款成功</div>
    <div class="ac name">俺来也</div>
    <div class="num ac"><span class="fs-60">￥</span>{{amount}}</div>
    <div class="btn-yellow suc-btn" @click="toOrderDetail">完成</div>
  </div>
</template>

<script>
    export default {
      name: 'SchoolPaySuc',
      data () {
        return {
          amount: '',
          redirectUrl: ''
        }
      },
      created () {
        this.amount = this.$route.query.payAmount
        this.redirectUrl = this.$route.query.redirectUrl
      },
      methods: {
        toOrderDetail () {
          localStorage.setItem('paySource','schoolPay')
          this.$router.push({ name: this.redirectUrl })
        }
      }

    }
</script>

<style scoped>
.schoolPay {
  background: #fff;
  height: 100vh;
  color: #2F2F2F;
}
.des {
  font-size: .6rem;
  text-align: center;
  padding: 1.06rem 0 1.01rem;
}
.name {
  font-size: .32rem;
  margin-bottom: .30rem;
}
.fs-60{
  font-size: .6rem;
}
.num{
  font-size: .84rem;
  color: #000000;
  font-weight: bold;
}
.suc-btn{
  border-radius: 48px;
  background: #FFDF00;
  width: 3.96rem;
  height: .9rem;
  line-height: .9rem;
  text-align: center;
  font-size: .32rem;
  margin: 4.27rem auto 0;
}
</style>



// WEBPACK FOOTER //
// SchoolPaySuc.vue?754626ad